module.exports = __webpack_public_path__ + "static/media/coletes.1ac6dc85.jpg";